/**************************************************
 * Created by nanyuantingfeng on 2018/5/3 18:16.
 **************************************************/
//如果有"独立部署"标签,就说明不需要埋点服务.
if (!IS_STANDALONE) {
  module.exports = require('./shence').default
}
